import { render, staticRenderFns } from "./retiro.vue?vue&type=template&id=f5850c98&scoped=true"
import script from "./retiro.vue?vue&type=script&lang=js"
export * from "./retiro.vue?vue&type=script&lang=js"
import style0 from "./retiro.vue?vue&type=style&index=0&id=f5850c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5850c98",
  null
  
)

export default component.exports